import _ from "lodash";

export default {
    namespaced: true,
    state: {
        info: {
            initialized: false,
            status: {
                created: false,
                ready: false,
                dead: false,
                status: "UNKNOWN",
                error: undefined,
            },
        },
    },
    getters: {
        isHealthy: (state) => {
            const s = state.info.status;
            return state.info.initialized && s.ready && !s.dead;
        },
    },
    mutations: {
        setInfo(state, status) {
            const old = Object.keys(status).reduce((acc, cur) => {
                acc[cur] = state.info.status[cur];
                return acc;
            }, {});
            if (!_.isEqual(status, old)) {
                state.info.status = status;
            }
            if (!state.info.initialized) state.info.initialized = true;
        },
    },
    actions: {},
};
